import React from 'react'
import PropTypes from 'prop-types'
import Datetime from 'react-datetime'

const AccessDate = props => {
  return (
    <div>
      <div className="form-check">
        <input
          onChange={props.onAvailableChange}
          type="radio"
          name="accessDate"
          id="accessDate1"
          className="form-check-input"
          checked={props.available}
        />
        <label className="form-check-label" htmlFor="accessDate1">
          Make available immediately
        </label>
      </div>
      <div className="form-check">
        <input
          onChange={props.onAvailableChange}
          type="radio"
          name="accessDate"
          id="accessDate2"
          className="form-check-input"
          checked={!props.available}
        />
        <label className="form-check-label" htmlFor="accessDate2">
          Make available after a certain date:
          <Datetime
            inputProps={{
              className: `${!props.available ? '' : 'd-none'}`,
              id: 'accessDatePicker',
              name: 'signupDateStart',
              type: 'text',
            }}
            onChange={value => props.onDateChange(value.toDate())}
            value={props.dateValue}
            closeOnSelect
          />
        </label>
      </div>
      <div className={`form-check ${!props.available ? '' : 'd-none'}`}>
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="invisibleCheck"
          checked={props.invisible}
          onChange={props.onInvisibleChange}
        />
        <label className="form-check-label" htmlFor="invisibleCheck">
          Hide from student until available date passes?
        </label>
      </div>
    </div>
  )
}

AccessDate.propTypes = {
  onDateChange: PropTypes.func,
  onAvailableChange: PropTypes.func,
  onInvisibleChange: PropTypes.func,
  available: PropTypes.bool,
  invisible: PropTypes.bool,
  dateValue: PropTypes.object,
}

export default AccessDate
